import React, { useState, useCallback } from 'react';
import { RefreshCw } from 'lucide-react';
import AdminLayout from '@/components/Admin/Layout/AdminLayout';
import SettingsLayout from '@/components/Admin/Settings/SettingsLayout';
import NotificationSettings from '@/components/Admin/Settings/Notification_Setting/NotificationSetting';

export default function NotificationManagementPage() {
  const [componentActions, setComponentActions] = useState(null);

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  // Action buttons for the header
  const headerActions = componentActions ? (
    <button
      onClick={componentActions.onRefresh}
      className="p-1.5 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 border border-slate-200"
    >
      <RefreshCw size={16} />
    </button>
  ) : null;

  return (
    <AdminLayout>
      <SettingsLayout actions={headerActions}>
        <NotificationSettings renderActions={handleActionsReady} />
      </SettingsLayout>
    </AdminLayout>
  );
}
